// src/app/features/dashboard/index.tsx
import { useAuth } from 'utils/AuthProvider';
import ClientDashboard from './client/ClientDashboard';
import AccountantDashboard from './accountant/AccountantDashboard';
import AdminDashboard from './admin/AdminDashboard';

const Dashboard = () => {
  const { isClient, isAccountant, isAdmin } = useAuth();

  if (isClient) return <ClientDashboard />;
  if (isAdmin) return <AdminDashboard />;
  if (isAccountant) return <AccountantDashboard />;
  return <></>;
};

export default Dashboard;
